module.exports = __webpack_public_path__ + "static/testEnv-e3815c2a87e766191f526bf70b09c858.svg";